import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const WindowsIcon = ({ color = 'white' }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height="12px"
			viewBox="0 0 10 11"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.63532 1.16854C6.25864 0.89327 7.88508 0.633928 9.51153 0.383789C9.51251 1.96368 9.51153 3.54239 9.51251 5.12219C7.88714 5.12911 6.26177 5.15652 4.63532 5.16226C4.63425 3.83023 4.63425 2.49939 4.63532 1.16854Z"
				fill={color}
			/>
			<path
				d="M0.512451 1.80584C1.73483 1.59686 2.96238 1.41638 4.18993 1.24609C4.19101 2.55636 4.19101 3.86553 4.19199 5.1758C2.96551 5.17471 1.73893 5.19519 0.512451 5.19182V1.80584Z"
				fill={color}
			/>
			<path
				d="M0.512451 5.60466C1.73795 5.60001 2.96345 5.62178 4.18895 5.6195C4.18895 6.93313 4.19199 8.24685 4.18993 9.56058C2.96551 9.35952 1.73893 9.18359 0.512451 8.99965V5.60466Z"
				fill={color}
			/>
			<path
				d="M4.62817 5.65674C6.25667 5.65674 7.88409 5.65674 9.5116 5.65674C9.51366 7.23208 9.5116 8.80732 9.5116 10.3839C7.88829 10.1142 6.26185 9.86408 4.63541 9.61958C4.63335 8.29903 4.63023 6.97848 4.62817 5.65674Z"
				fill={color}
			/>
		</Icon>
	);
};
